module.exports = __webpack_public_path__ + "static/media/character_frame.02278991.png";